/**
 * WebGL layer
 * @class WebGLLayer
 * @param {String} name
 * @constructor
 */
function WebGLLayer(name) {
	this.name = name;
	this.textures = [];

	this.blending = {
		separate: false,
		sFactor: WebGLRenderingContext.SRC_ALPHA,
		dFactor: WebGLRenderingContext.ONE_MINUS_SRC_ALPHA
	};
}

/** @type {String} */
WebGLLayer.prototype.name = null;
/** @type {Array.<WebGLTexture>} */
WebGLLayer.prototype.textures = null;
WebGLLayer.prototype.textureSize = 4096;
/** @type Object */
WebGLLayer.prototype.frames = null;
/*
 * Blending is decomposing in two cases:
 * if separate is true, blending must implement 4 properties:
 *  - srcRGB, source scaling factor for the source RGB values
 *  - dstRGB, destination scaling factor for the destination RGB values
 *  - srcAlpha, source scaling factor for the source alpha value
 *  - dstAlpha, destination scaling factor for the destination alpha value
 * else, it must implement 2 properties:
 *  - sFactor, source scaling factor
 *  - dFactor, destination scaling factor
 */
WebGLLayer.prototype.blending = null;
WebGLLayer.prototype.depth = 0;
WebGLLayer.prototype.zoomLevel = 1;
/*
* The 2 following variables are percentages, with 100% = 1.0
* */
WebGLLayer.prototype.zoomOffsetX = 0;
WebGLLayer.prototype.zoomOffsetY = 0;



WebGLLayer.prototype._getFrame = function _getFrame(progressX, progressY){
	if(!this.frames){
		return null;
	}

	return this.frames[Math.round(progressX * (this.frames.length - 1))];
};

/**
 *
 * @param {Number} progressX
 * @param {Number} progressY
 * @return {Array.<Number>}
 */
WebGLLayer.prototype.getTexCoords = function getTexCoords(progressX, progressY) {
	var frame = this._getFrame(progressX, progressY);
	if(frame) {
		var x = frame.x / this.textureSize,
			y = frame.y / this.textureSize,
			width = frame.width / this.textureSize,
			height = frame.height / this.textureSize;
		return [
			x, y,
			x + width, y,
			x, y + height,
			x, y + height,
			x + width, y,
			x + width, y + height
		];
	} else {
		return [
			0, 0,
			0, 0,
			0, 0,
			0, 0,
			0, 0,
			0, 0
		];
	}
};

/**
 *
 * @param {Number} progressX
 * @param {Number} progressY
 * @param {Number} canvasWidth
 * @param {Number} canvasHeight
 * @return {Array.<Number>}
 */
WebGLLayer.prototype.getRectCoords = function getRectCoords(progressX, progressY, canvasWidth, canvasHeight) {
	var frame = this._getFrame(progressX, progressY);
	if(frame) {
		// Take account the depth
		progressY = - this.depth * (1 - progressY) / 2;
		var heightRatio = canvasHeight / 1080;
		var textureRatio = 4096 / this.textureSize;
		var offsetX = canvasWidth * this.zoomOffsetX * (progressX - 0.5) / 2;
		var offsetY = canvasHeight * this.zoomOffsetY * (progressY - 0.5) / 2;
		//Calculation of position relative to the center of the width
		var x = (frame.sourceX * textureRatio - 1460) * heightRatio * this.zoomLevel + offsetX + canvasWidth / 2;
		var y = (frame.sourceY * textureRatio - 540) * heightRatio * this.zoomLevel + offsetY + canvasHeight / 2;
		var width = frame.width * textureRatio * heightRatio * this.zoomLevel;
		var height = frame.height * textureRatio * heightRatio * this.zoomLevel;
		return [
			x, y + y * progressY,
			x + width, y + y * progressY,
			x, y + height + y * progressY,
			x, y + height + y * progressY,
			x + width, y + y * progressY,
			x + width, y + height + y * progressY
		];
	} else {
		return [
			0, 0,
			0, 0,
			0, 0,
			0, 0,
			0, 0,
			0, 0
		];
	}
};

/**
 *
 * @param progressX
 * @param progressY
 * @returns {WebGLTexture}
 */
WebGLLayer.prototype.getTexture = function getTexture(progressX, progressY){
	var frame = this._getFrame(progressX, progressY);
	if(!frame){
		return null;
	}

	return this.textures[frame.id];
};

WebGLLayer.prototype.toString = function toString(){
	return "[object WebGLLayer name=\"" + this.name + "\"]";
};